import {
  Component, Input, Output,
  EventEmitter, AfterViewInit, ElementRef,
  Renderer2, OnChanges, SimpleChanges,
  ViewEncapsulation, forwardRef
} from '@angular/core';

import {
  NG_VALUE_ACCESSOR, NG_VALIDATORS,
  ControlValueAccessor, Validator
} from '@angular/forms';

import { Inject } from '@angular/core';
import { DOCUMENT } from '@angular/platform-browser';

declare const Quill:any;

const VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => EditorComponent),
  multi: true
};
const VALUE_VALIDATOR: any = {
  provide: NG_VALIDATORS,
  useExisting: forwardRef(() => EditorComponent),
  multi: true
};
@Component({
  selector: 'bui-editor',
  template: `<ng-content select="[quill-editor-toolbar]"></ng-content>`,
  providers: [VALUE_ACCESSOR, VALUE_VALIDATOR],
  encapsulation: ViewEncapsulation.None,
  styles: [
    `.ql-toolbar.ql-snow {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.ql-container.ql-snow {
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}
.ql-container .ql-editor {
  min-height: 200px;
  padding-bottom: 10px;
}
`
  ]
})
export class EditorComponent implements AfterViewInit, ControlValueAccessor, OnChanges {

  editor: any; // 编辑器对象
  editorElem: HTMLElement; // 编辑的dom容器
  emptyArray: any[] = [];
  content: any; // 内容
  defatulModules = { // 默认配置模块
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],        // 切换按钮
      ['blockquote', 'code-block'],

      [{ 'header': 1 }, { 'header': 2 }],               // 自定义按钮值
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      [{ 'script': 'sub' }, { 'script': 'super' }],      // 上/下标
      [{ 'indent': '-1' }, { 'indent': '+1' }],          // 缩进
      [{ 'direction': 'rtl' }],                         // 文本方向
      [{ 'size': ['small', false, 'large', 'huge'] }],  // 自定义下拉
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

      [{ 'color': this.emptyArray.slice() }, { 'background': this.emptyArray.slice() }], // 默认主题的下拉菜单
      [{ 'font': this.emptyArray.slice() }],
      [{ 'align': this.emptyArray.slice() }],

      ['clean'], // 清除格式按钮
      ['link', 'image', 'video'] // 链接、图像、视频按钮
    ]
  };

  // 主题
  @Input() theme: string;

  // 模块配置
  @Input() modules: { [index: string]: Object };

  @Input() readOnly: boolean;

  @Input() placeholder: string;

  @Input() maxLength: number;

  @Input() minLength: number;

  @Input() required: boolean;

  @Input() formats: string[];

  @Input() style: any = {};

  @Input() strict = true;

  @Input() scrollingContainer: HTMLElement | string;

  @Input() bounds: HTMLElement | string;

  // 创建编辑器时
  @Output() onEditorCreated: EventEmitter<any> = new EventEmitter();

  // 内容改变时
  @Output() onContentChanged: EventEmitter<any> = new EventEmitter();

  // mark model as touched if editor lost focus
  @Output() onSelectionChanged: EventEmitter<any> = new EventEmitter();

  onModelChange: Function = () => { };
  onModelTouched: Function = () => { };

  constructor(private elemRef: ElementRef, @Inject(DOCUMENT) private doc, private render: Renderer2) { }

  ngAfterViewInit(): void {
    const toolbarElem = this.elemRef.nativeElement.querySelector('[quill-editor-toolbar]');
    let modules: any = this.modules || this.defatulModules;
    if (toolbarElem) {
      modules['toolbar'] = toolbarElem;
    }
    this.elemRef.nativeElement.insertAdjacentHTML('beforeend', '<div quill-editor-element></div>');
    this.editorElem = this.elemRef.nativeElement.querySelector('[quill-editor-element]');
    if (this.style) {
      Object.keys(this.style).forEach((key: string) => {
        this.render.setStyle(this.editorElem, key, this.style[key]);
      });
    }
    
    this.editor = new Quill(this.editorElem, {
      modules: modules,
      placeholder: this.placeholder || '请输入内容',
      readOnly: this.readOnly || false,
      theme: this.theme || 'snow',
      formats: this.formats,
      bounds: this.bounds || this.doc.body,
      strict: this.strict,
      scrollingContainer: this.scrollingContainer
    });

    if (this.content) {
      const contents = this.editor.clipboard.convert(this.content);
      this.editor.setContents(contents);
      this.editor.history.clear();
    }

    this.onEditorCreated.emit(this.editor);

    this.editor.on('selection-change', (range: any, oldRange: any, source: string) => {
      this.onSelectionChanged.emit({
        editor: this.editor,
        range: range,
        oldRange: oldRange,
        source: source
      });
      if (!range) {
        this.onModelTouched();
      }
    });

    this.editor.on('text-change', (delta: any, oldContents: any, source: string) => {
      let html: (string | null) = this.editorElem.children[0].innerHTML;
      const text = this.editor.getText();
      if (html === '<p></br></p>') {
        html = null;
      }
      this.onModelChange(html);
      this.onContentChanged.emit({
        editor: this.editor,
        html: html,
        text: text,
        delta: delta,
        oldContents: oldContents,
        source: source
      });
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['readOnly'] && this.editor) {
      this.editor.enable(!changes['readOnly'].currentValue);
    }
  }

  writeValue(currentValue: any): void {
    this.content = currentValue;
    if (this.editor) {
      if (currentValue) {
        this.editor.setContents(this.editor.clipboard.convert(this.content));
        return;
      }
      this.editor.setText('');
    }
  }
  registerOnChange(fn: any): void {
    this.onModelChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onModelTouched = fn;
  }
  // setDisabledState?(isDisabled: boolean): void {
  //   this.readOnly = !!isDisabled;
  // }

  validate(): Object {
    if (!this.editor) {
      return null;
    }

    let err = { };

    let valid = true;

    const textLength = this.editor.getText().trim().length;

    if (this.minLength && textLength && textLength < this.minLength) {
      err['minLengthError'] = {
        given: textLength,
        minLength: this.minLength
      };
      valid = false;
    }
    if (this.maxLength && textLength && textLength > this.maxLength) {
      err['maxLengthError'] = {
        given: textLength,
        maxLength: this.maxLength
      };
      valid = false;
    }
    if (this.required && !textLength) {
      err['requiredError'] = {
        empty: true
      };

      valid = false;
    }
    return valid ? null : err;
  }
}
